import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { getBaseUrl } from "../config";
import { getAuthApiHeaders } from "../../utils/common";
import { showSnackbar } from "./snackbar";
import { getApiErrorMessage } from "../../utils/apiError";
import secureLocalStorage from "react-secure-storage";
const baseUrl = getBaseUrl();
export const getRBDPerformanceMetrics = createAsyncThunk(
  "rbdPerformanceMetrics/getRBDPerformanceMetrics",
  async (_, { rejectWithValue, dispatch }) => {
    try {
      const response = await axios.get(`${baseUrl}/rbd_kpi`, {
        headers: {
          "Content-Type": "application/json",
          "use-case": "src",
          ...getAuthApiHeaders(),
          client: "UT",
        },
        withCredentials: true,
      });
      return response.data;
    } catch (error) {
      dispatch(showSnackbar({ message: "Failed to load!", severity: "error" }));
      return rejectWithValue(getApiErrorMessage(error));
    }
  },
  {
    // My Performance and the chat page's goals disclaimer both request this
    // on first load; one in-flight request serves both.
    condition: (_, { getState }) => !getState()?.rbdPerformanceMetrics?.isLoading,
  },
);

const rbdPerformanceMetricsSlice = createSlice({
  name: "rbd-performance-metrics",
  initialState: {
    isLoading: false,
    rbdMetrics: {},
    isError: false,
    error: null,
    success: false,
  },
  extraReducers: (builder) => {
    builder.addCase(getRBDPerformanceMetrics.pending, (state, action) => {
      state.isLoading = true;
      state.error = null;
    });
    builder.addCase(getRBDPerformanceMetrics.fulfilled, (state, action) => {
      state.isLoading = false;
      state.rbdMetrics = action.payload;
      state.success = true;
    });
    builder.addCase(getRBDPerformanceMetrics.rejected, (state, action) => {
      state.isLoading = false;
      state.isError = true;
      state.error = action.payload;
      state.success = false;
    });
  },
});

export default rbdPerformanceMetricsSlice.reducer;
